import styled from 'styled-components';
import { media } from '../../../style/media';
import { white, contiOrange } from '../../../style/colors';

export const Controls = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  flex-wrap: wrap;
`;

export const ViewToggle = styled.div`
  display: flex;
  gap: 4px;
  background: #f3f4f6;
  padding: 4px;
  border-radius: 8px;
`;

export const ToggleButton = styled.button`
  padding: 8px 16px;
  border: none;
  background: ${(props) => (props.$active ? white : 'transparent')};
  color: ${(props) => (props.$active ? '#111827' : '#6b7280')};
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: ${(props) => (props.$active ? '0 1px 3px rgba(0, 0, 0, 0.1)' : 'none')};

  &:hover {
    color: #111827;
  }

  ${media.s`
    padding: 6px 12px;
    font-size: 13px;
  `}
`;

export const Select = styled.select`
  padding: 10px 14px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 14px;
  color: #111827;
  background: ${white};
  cursor: pointer;
  transition: all 0.2s;

  &:focus {
    outline: none;
    border-color: ${contiOrange};
    box-shadow: 0 0 0 3px rgba(255, 165, 0, 0.1);
  }
`;

export const Button = styled.button`
  padding: 10px 24px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  border: none;
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;

  ${(props) =>
    props.$primary
      ? `
    background: ${contiOrange};
    color: ${white};
    
    &:hover {
      background: #ff8c00;
      box-shadow: 0 4px 12px rgba(255, 165, 0, 0.3);
    }
  `
      : `
    background: #f3f4f6;
    color: #374151;
    
    &:hover {
      background: #e5e7eb;
    }
  `}

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  i {
    font-size: 18px;
  }

  ${media.s`
    padding: 8px 16px;
    font-size: 13px;
  `}
`;

export const IconButton = styled.button`
  background: transparent;
  border: none;
  padding: 6px;
  cursor: pointer;
  color: #6b7280;
  border-radius: 6px;
  transition: all 0.2s;

  &:hover {
    background: #f3f4f6;
    color: #111827;
  }

  i {
    font-size: 16px;
  }
`;

export const ActionButtons = styled.div`
  display: flex;
  gap: 4px;
  justify-content: flex-end;
`;

